<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addDiscountForm" (ngSubmit)="saveChanges(addDiscountForm.value)">
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Descripción</mat-label>
                                <input matInput formControlName="description" required>
                                <mat-error *ngIf="addDiscountForm.controls['description'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error
                                    *ngIf="addDiscountForm.controls['description'].hasError('cannotContainSpace')">
                                    La descripción no puede ser un espacio en blanco
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Valor de descuento</mat-label>
                                <input matInput type="number" formControlName="value" required>
                                <mat-hint>En %</mat-hint>
                                <mat-error *ngIf="addDiscountForm.controls['value'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addDiscountForm.controls['value'].hasError('min')">
                                    El valor debe ser mayor a 0.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="status" required>
                                    <mat-option *ngFor="let option of status" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addDiscountForm.controls['status'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="40">
                            <mat-form-field appearance="outline">
                                <mat-label>Imagen</mat-label>
                                <ngx-mat-file-input formControlName="image" accept=".png, .jpg, .jpeg">
                                </ngx-mat-file-input>
                            </mat-form-field>
                        </div>
                        <div fxFlex="10" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                            <img class="image-preview" [src]="ImageUrl" />
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="100">
                            <mat-form-field appearance="outline">
                                <mat-label>Productos</mat-label>
                                <mat-select formControlName="items" multiple>
                                    <mat-option *ngFor="let option of allItems" [value]="option.cdItem">
                                        {{option.dsName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button type="submit" [disabled]="!addDiscountForm.valid" mat-raised-button
                        class="save-changes">GUARDAR
                        CAMBIOS</button>
                    <button routerLink="/store-discount" mat-raised-button class="cancel-changes">CANCELAR</button>
                </div>
            </form>
        </section>

    </div>
</div>